export const createProductLineItem = `
    mutation createProductLineItem($input: CreateProductLineItemInput!) {
        createProductLineItem(input:$input) {
            id
            productId
            product {
                id
                name
            }
            productFeatureId
            productFeature {
                id
                name
            }
            position
            createdByUsername
            created
            updated
    }
}`;

export const updateProductLineItem = `
    mutation updateProductLineItem($input: UpdateProductLineItemInput!) {
        updateProductLineItem(input:$input){
            id
            productId
            product {
                id
                name
            }
            productFeatureId
            productFeature {
                id
                name
            }
            position
            createdByUsername
            created
            updated
        }
}`;

export const deleteProductLineItem = `
    mutation deleteProductLineItem($input: DeleteProductLineItemInput!) {
        deleteProductLineItem(input:$input) 
}`;
